import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { ISeance } from '../../types/seance';
import { changeToZeroMoment } from '../timeHelpers';
import SeanceEnum from 'src/enumerables/seance-enum';
import { exportToCsv } from '../../services/exports/csv';
import { numberWithCommas } from '../format';
const statusEnum = SeanceEnum ? SeanceEnum.getEnum('SeanceStatus') : {};

export const groupInvoiceToCsv = (data: ISeance[]) => {
    const groupData: any = [
        [
            '#',
            'Status',
            'Service Type',
            'Service Location',
            'Min Per Unit',
            'Student Addition',
            'Session Date',
            'Start Time',
            'End Time',
            'External Rate per Hour',
            'External Rate per Unit',
            'Internal Rate per Hour',
            'Internal Rate per Unit',
            'Total Units',
            'Total Fee',
            'SignDoc',
        ],
    ];

    data.forEach((it) => {
        let serviceType = it?.serviceType?.title;
        if (!serviceType) {
            serviceType = it?.serviceType?.cpt;
        }
        const locationArr: string[] = [];
        locationArr.push(it['serviceLocation'] ? it['serviceLocation']?.title : '');
        if (it.isHome) {
            locationArr.push('[Home]');
        }
        if (it.isInPerson) {
            locationArr.push('[In Person]');
        }
        if (it.isTelehealth) {
            locationArr.push('[Telehealth]');
        }
        const serviceLocation = locationArr.join(', ');

        const statusItems: SelectObject[] = getValFromEnum(statusEnum);
        let valueCaseStatus = '';

        statusItems.forEach((itSt, l, arr) => {
            if (+itSt.value === +it.status) {
                valueCaseStatus = itSt.label;
            }
        });

        groupData.push([
            it.id,
            valueCaseStatus,
            serviceType,
            serviceLocation,
            it.minPerUnit,
            it.seanceInfo,
            it.seanceDate ? changeToZeroMoment(it['seanceDate'], 'MMM D, YYYY') : '',
            it.startTime ? changeToZeroMoment(it['startTime'], 'LT') : '',
            it.endTime ? changeToZeroMoment(it['endTime'], 'LT') : '',
            it.externalRatePerHour ? `${numberWithCommas(it.externalRatePerHour)}` : '$0.00',
            it.externalRatePerUnit ? `${numberWithCommas(it.externalRatePerUnit)}` : '$0.00',
            it.internalRatePerHour ? `${numberWithCommas(it.internalRatePerHour)}` : '$0.00',
            it.internalRatePerUnit ? `${numberWithCommas(it.internalRatePerUnit)}` : '$0.00',
            it.totalUnit,
            it.totalFee,
            it['signDoc'] ? `${it['signDoc']}` : '',
        ]);
    });
    exportToCsv('Cases&Sesions.csv', groupData);
};
